<template>
	<div class="practice-component">
		<template v-if="isGuest && isLimitGuest"><!--  -->
			<h4 class="title-guest-limit">You reached practices of the day: <a :href="route('login', {role: 'learner'})">Log in </a> to continue</h4>
			<p class="limit text">To continue, you must sign in as learner so you can:</p>
			<ol class="advantages-signed-in">
				<li class="advantage">Have full acess to skills</li>
				<li class="advantage">Access mores exercices with upper 100.000.000 practices for improve your skills</li>
				<li class="advantage">Save your results</li>
				<li class="advantage">Retrieve your scores with graphic that show your progression</li>
				<li class="advantage">Make homework</li>
				<li class="advantage">Share your scores and progressions with yours classmate</li>
				<li class="advantage">Win trophies</li>
				<li>Many others suprises are waiting for you there...</li>
			</ol>
		</template>
		<template v-else>
			<BaseExercise
				:best-stats="bestStats"
				:edit-route="withEdit ? route('admin.practices.edit', {practice: currentPractice.id || practices[0].id}) : null"
				:display-title="false"
				:hover-prop="hoverProposition"
				:index-quiz="practiceData.index_question"
				:is-group="false"
				:level="level"
				limit-time-per-quiz="limitTimePerQuiz"
				:number-practices-per-activity="numberPractices || learner.framer_settings.practices_per_activity"
				:problems="practices"
				:remain-time="remainTime"
				:reportPractice="reportPracticeError"
				:save-score="saveScore"
				:title-practice="exerciseTitle"
				:treated-quizes="solvedQuizesProp"
				:truths-answers="practiceData.truths_questions"
				:with-report="true"
				@empty-answer="emptyAnswer"
				@end="isEnd = $event"
				@fail-answer="failAnswer"
				@played-question="update_played_questions"
				@quiz="currentPractice = $event"
				@restart="restartGame"
				@score="score = $event"
				@truth-answer="truthAnswer"
			>
				<template v-slot:advice-login>
					<div class="login-advice-switch-volume">
						<slot name="advice-login">
							<p></p>
						</slot>
						<div class="switch-sound-div">
							<button class="btn btn-light" @click="activeSound = !activeSound" type="button" v-tooltip="activeSound ? `Disable sound` :`Active sound` ">
								<i class="fa fa-volume-up" v-if="activeSound"></i>
								<!-- <i class="fas fa-volume-mute" v-else></i> -->
								<span class="sound-mute" v-else>
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="1em"><path d="M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"/></svg>
								</span>
							</button>
						</div>
					</div>
				</template>
				<template v-slot:after-score>
					<score :score="score" :session-time="sessionTime" :activity-time="activityTime" :achievement="achievement" :loaded="loaded" @time="setTime" :is-end="isEnd" :key="`score-component-${tries}`" :lesson-link="skill.lesson_link ? route('lessons.show', {grade: grade, grade_topic: skill.grade_topic, skill: skill}) : null" :worksheet-link="worksheetLink" :grade="grade" />
				</template>
				<template v-slot:buttons-menu>
					<slot name="menu-learner"></slot>
				</template>
				<template v-slot:col-after-score-problem>
					<slot name="col-after-score-problem"></slot>
				</template>
			</BaseExercise>
		</template>
	</div>
</template>
<script type="text/javascript">
	import BaseExercise from 'base-exercise';
	import Score from './components/Score/template';
	import Fnc from 'usefull-functions';
	import { Quiz } from 'base-exercise';

	export default {
		name: "practice-component",
		components: { BaseExercise, Score },
		props: {
		 	exerciseTitle: {type: String, required: false, default: ''},
		 	homeworkId: {type: [String, Number], required: false, default: 0},
		 	grade: {
		 		type:Object,
		 		required:false,
		 		default() {
		 			return {id: 0, link: 'any', title: 'All levels'};
		 		}
		 	},
		 	skill: {type: Object, required: true},
		 	isSkill: {type: Boolean, required: false, default: true},
		 	level: {
		 		type: String,
		 		required: false,
		 		default: 'any'
		 	},
		 	isLearner: {type: [Boolean, Number], default: false},
		 	withEdit: {type: Boolean, default: false},
		 	practices: { default: () => ([]) },
		 	learner: { default: () => ({}) },
		 	bestStats: { default: () => null },
		 	numberPractices: { required: false },
		 	loaded: { default: false },
		 	achievement: { type: Object, default: () => ({ value: 0, label: 'Total answered', key: 'total_questions' }) },
		 	failAudioUrl: { type: String, default: location.origin + '/sounds/fail.mp3'},
		 	emptyAudioUrl: { type: String, default: location.origin + '/sounds/empty.mp3'},
		 	successAudioUrl: { type: String, default: location.origin + '/sounds/success.mp3'},
		 	withSound: { type: Boolean, default: true }, // Enable or disable sound setting.
		 	practiceData: { required: false }, // activity data, we use it to follow activity. This object included current session data
		 	resourceType: { default: 'skill' }, // Skill or Tag
		 	activityTime: { type: Number, default: null }, // Activity duration, suitable for assessment with a limit duration
		 	maxActivityTime: { default: process.env.MIX_MAX_ACTIVITY_TIME || 5400 },
		 	limitDailyPractices: { default: process.env.MIX_LIMIT_DAILY_PRACTICES_GUEST || 10 },
		 	limitTimePerQuiz: { default: false },
		 	worksheetLink: { required: false, type: String }
		},
		data() {
			let emptyAudio = new Audio(), failAudio = new Audio(), successAudio = new Audio(), beepAudio = new Audio(), indexQuiz = 0;
			emptyAudio.src = this.emptyAudioUrl;
			failAudio.src = this.failAudioUrl;
			successAudio.src = this.successAudioUrl;
			beepAudio.src = location.origin + '/sounds/beep.mp3';
			if (this.practiceData != null && this.practiceData.index_question != null){
				indexQuiz = this.practiceData.index_question;
			}
		 	return {
		 		yourBestScore: 0,
		 		generalBestScore: 0,
		 		bestScoreName: 'Kevin',
		 		isGuest: !this.isLearner,
		 		currentPractice: this.practices[indexQuiz],
		 		score: {},
		 		emptyAudio: emptyAudio,
		 		elapsedTime: 0,
		 		successAudio: successAudio,
		 		failAudio: failAudio,
		 		beepAudio: beepAudio,
		 		isEnd: false,
		 		solved: this.practiceData.treated || [],
		 		solvedQuizesProp: [],
		 		activeSound: (this.withSound || (Fnc.getCookie('activeSound') != null && Fnc.getCookie('activeSound') == "true")),
		 		sessionTime: this.practiceData.elapsed_time,
		 		isRestart: false,
		 		start: new Date().getTime(),
		 		tries: 1,
		 	};
		},
		created() {
			this.solvedQuizesProp = this.solved.map(solved => {
		 			let vars = solved.quiz.vars, quiz = new Quiz(Object.assign({...this.practices[solved.index], vars: vars}));
		 			return {
		 				...solved,
		 				quiz: quiz,
		 			}
		 		});
		 },
		mounted(){
		},
		computed:{
		 	isLimitGuest () {
		 		return this.played_questions >= this.limitDailyPractices;
		 	},
		 	played_questions () {
		 		return Number(Fnc.getCookie('MWP_played_questions', 0));
		 	},/*
		 	limitDailyPractices () {
		 		return Number(process.env.MIX_LIMIT_DAILY_PRACTICES_GUEST) + 5000;
		 	},*/
		 	indexQuiz() {
		 		if (this.currentPractice == undefined)
		 			return undefined;
		 		let i = -1, practice = {};
		 		do {
		 			i++;
		 			practice = this.practices[i];
		 		} while (this.currentPractice.id != practice.id && i < this.practices.length);
		 		return i;
		 	},
		 	currentSession() {
		 		let obj = Object.assign({ ...this.practiceData }, {}), steps = this.practiceData.steps || [];
		 		obj.elapsed_time = this.elapsedTime;
		 		obj.index_question = this.currentPractice.index + 1;
		 		obj.truths_questions = this.score.succed;
		 		obj.resource_type = this.resourceType;
		 		obj.treated = this.score.treated.map(treated => {
		 			return {
		 				submited: treated.submited,
		 				found: treated.found,
		 				index: treated.index,
		 				quiz: { id: treated.quiz.id, vars: treated.quiz.vars},
		 				submited: treated.submited,
		 				duration: treated.duration
		 			};
		 		});/*
		 		steps.push({
		 			elapsedTime: this.elapsedTime - this.practiceData.elapsed_time,
		 			truths_questions: this.practiceData.truths_questions - this.score.succed,
		 			index_question: { from: this.practiceData.index_question, to: this.indexQuiz},
		 			start: this.start,
		 			end: (new Date()).getTime()
		 		});
		 		obj.steps = steps;*/
		 		return obj;
		 	},
		 	currentActivitySession() {
		 		return {
		 			elapsedTime: this.elapsedTime - this.practiceData.elapsed_time,
		 			truths_questions: this.score.succed - this.practiceData.truths_questions,
		 			index_question: { from: this.practiceData.index_question, to: this.indexQuiz},
		 			start: this.start,
		 			end: (new Date()).getTime()
		 		};
		 	},
	        truthsQuestionsProps() {
	            return this.practiceData.truths_questions;
	        },
	        solvedQuizes() {
	        	return this.solved.map(solved => {
		 			let vars = solved.quiz.vars, quiz = new Quiz(Object.assign({...this.practices[solved.index], vars: vars}));
		 			return {
		 				...solved,
		 				quiz: quiz,
		 			}
		 		})
	        },
	        remainTime() {
	        	return Math.max((this.activityTime || this.maxActivityTime) - this.elapsedTime, 0);
	        }
		},
		methods: {
			hoverProposition() {
				this.beepAudio.play();
			},
			restartGame() {
				this.sessionTime = 0;
				if (this.activityTime != null && Number(this.activityTime) == this.activityTime) {
					if (this.score.passed < this.practices.length / 2) {
						this.tries++;
					}
				}
				this.solved = [];
				this.isRestart = true;
			},
		 	saveScore(stats, rand = false){
	 			if (this.isGuest) {
	 				this.$swal.fire({
	 					title: 'We can\'t save score if you are not authenticated.',
	 					html: Fnc.tag('div', Fnc.tag('a', 'Log in', {href: route('login', {role: 'learner'})}) + ' to store your score and follow your progression'),
	 					icon: 'error'
	 				});
	 				return ;
	 				throw new Error('You have to login as leaner to save your score.');
	 			}

		 		let total_questions = rand ? 10 : 0, truths_questions = rand ? rn(total_questions / 2, total_questions) : 0, session = this.currentSession,
	 			datas = Object.assign({
	 				total_questions: total_questions,
	 				truths_questions: truths_questions,
	 				elapsed_time: this.elapsedTime,
	 				practice_session: {
	 					datas: session.datas,
	 					elapsed_time: session.elapsed_time,
	 					learner_id: session.learner_id,
	 					problems: session.problems,
	 					resource_type: session.resource_type,
	 					skill_id: session.skill_id,
	 					total_questions: session.total_questions,
	 					truths_questions: session.truths_questions,
	 					steps: this.currentActivitySession,
	 					treated: session.treated
	 				}
	 			}, stats, {
	 				skill: this.skill.id,
	 				homework_id: alt_0(this.homeworkId, null),
	 			});
	 			datas.reviews = undefined;

	 			this.isSavingScore = true;

	 			axios.post(route('learner.scores.store', this.data_learner.id), datas).then(res => {
	 				this.$swal('Right!', 'Your score was been saved successfully', 'success');
	 			}).catch(err => {
	 			}).finally(() => {
	 				this.isSavingScore = false;
	 			});
		 	},
		 	update_played_questions(){
		 		this.solved = this.score.treated;
				axios.put(route('psession.update', this.practiceData.id), {...this.currentSession, steps: this.currentActivitySession}).then(res => {
					// log('updated current session with result:', res)
				});

		 		let played = Fnc.getCookie('MWP_played_questions', 0);
		 		var tomorrow = new Date();
				tomorrow.setDate(tomorrow.getDate() + 1);
		 		Fnc.setCookie('MWP_played_questions',  this.played_questions + 1, tomorrow.toUTCString());
		 	},
		 	load_best_stats(){
		 		this.best_stats = {
			 		best_score_of_player: 0,
			 		best_player_score: 0,
			 		best_player_name: 'Kevin'
		 		}
		 	},
		 	reportPracticeError(payload) {
		 		// log_error('practice has error:', payload);
		 		this.$swal.fire({
		 			icon: 'info',
		 			title: 'You want to report this practice!',
		 			html: Fnc.tag('h6', 'Please write your review here') +
		 				Fnc.tag('textarea', '', {class: 'form-control', id: 'practice-report-comment', cols: 30, rows: 10, placeholder: 'Please explain your review', value: `practice_id: ${payload.id}\n`}),
		 			showCancelButton: true,
		 			closeOnConfirm: false,
		 			showLoaderOnConfirm: true,
		 		}).then(response => {
		 			if (response.isConfirmed) {
		 			let comment = response == '' ? 'No comment' : document.getElementById('practice-report-comment').value || 'No comment provided';
		 			axios.post(route('practice.report'), {property: 'Practice', 'skill-link': this.skill.link, grade: this.grade.link, problem: payload.problem, id: payload.id, comment: comment});
		 			this.$swal.fire({
		 				title: 'Good!!',
		 				icon: 'success',
		 				html: Fnc.tag('h3', 'You reported') + Fnc.tag('p', comment, {class: 'text-info'})
		 			});
		 			}
		 		})
		 	},
		 	truthAnswer(val) {
		 		if(this.activeSound){
		 			this.successAudio.play();
		 		}
		 	},
		 	failAnswer(val) {
		 		if(this.activeSound){
		 			this.failAudio.play();
		 		}
		 	},
		 	emptyAnswer(val) {
		 		// log('empty-response with val:', val, 'emptyAudio:', this.emptyAudio);
		 		if (this.activeSound){
		 			this.emptyAudio.play();
		 		}
		 	},
		 	setTime(time) {
		 		// log('@time occured by scoreboard with value:', time);
		 		this.elapsedTime = time.elapsed;
		 		// log('@time occured by scoreboard with value:', time, 'this.elapsedTime:', this.elapsedTime);
		 	}
		},
		watch: {
			activeSound(value) {
				Fnc.setCookie('activeSound', value, null, 300);
			},
			elapsedTime(time) {/*
				axios.put(route('psession.update', this.practiceData.id), this.currentSession).then(res => {
					// log('updated current session with result:', res)
				});*/
			},
			score(score) {
			},
			currentPractice(quiz) {
				this.$emit('quiz', quiz);
			}
			/*
			indexQuiz(index) {
			},
			elapsedTime(value) {
			},
			currentSession(value) {
			}*/
		}
	};
</script>

<style lang="scss" src="./style.scss" lang="scss"></style>